export default "__VITE_ASSET__BpvBwbHH__"